/* eslint-disable @next/next/no-img-element */
import styled from 'styled-components';
// import Image from 'next/image';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { format, parseISO } from 'date-fns';
import { de, da, es, enUS } from 'date-fns/locale';
import i18n from 'utils/i18n';

export type VideoItemProps = {
  video: FeedItem;
};

export const VideoItem: React.FC<VideoItemProps> = ({ video }) => {
  const router = useRouter();
  const currentPath = router.asPath.split('?')[0];
  const { locale } = useRouter();

  const localeMapping: Record<AcceptedLocales, Locale> = {
    'en-US': enUS,
    de: de,
    es: es,
  };

  const formatString = locale === 'de' ? 'EEE, dd. MMM yyyy' : 'EEE MMM dd yyyy';

  return (
    <StyledVideoItem>
      <article>
        {video.imageUrl && (
          <div className="img">
            {video.externalLink ? (
              <a href={video.externalLink} target="_blank" rel="noopener noreferrer" className="h3">
                <img src={video.imageUrl} alt={video.title} />
              </a>
            ) : (
              <Link href={`${currentPath}?id=${video.id}`} className="h3">
                <img src={video.imageUrl} alt={video.title} />
              </Link>
            )}
          </div>
        )}
        <div className="details">
          {video.externalLink ? (
            <a
              href={video.externalLink}
              target="_blank"
              rel="noopener noreferrer"
              className="h3"
              dangerouslySetInnerHTML={{ __html: video.title }}
            />
          ) : (
            <Link
              href={`${currentPath}?id=${video.id}`}
              className="h3"
              dangerouslySetInnerHTML={{ __html: video.title }}
            ></Link>
          )}
          {/* <div className="published">{new Date(video.published).toDateString()}</div> */}
          <div className="published">
            {format(parseISO(`${video.published}` as string), formatString, {
              locale: localeMapping[locale] || enUS,
            }).replace(/\b([A-Z][a-z])\.(?=[,\s]|$)/g, '$1')}
          </div>
          <div className="description">{video.description}</div>
        </div>
      </article>
    </StyledVideoItem>
  );
};

export const StyledVideoItem = styled.article`
  background-color: var(--body-background);
  border: 1px solid var(--border-white-high-contrast);
  border-color: transparent;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  box-shadow: 0 1.6px 3.6px 0 var(--box-shadow-medium), 0 0.3px 0.9px 0 var(--box-shadow-light);
  color: var(--text);
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-start;
  outline-color: var(--text);

  .img {
    width: 100%;
    /* padding-top: 56.25%; */
    position: relative;
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;

    img {
      width: 100%;
      border-top-left-radius: 0.5rem;
      border-top-right-radius: 0.5rem;
    }
  }

  .details {
    border: 1px solid var(--border-white-high-contrast);
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: flex-start;
    padding: 1rem;
    width: 100%;

    .h3 {
      font-size: 1rem;
      font-weight: 600;
      line-height: 1.25;
      text-align: left;
      margin: 0.3rem 0 0.3rem 0;
    }

    .published {
      font-size: 0.875rem;
      font-weight: 600;
    }

    .description {
      color: var(--text-subtle);
      font-size: 0.875rem;
      line-height: 1.5;
    }
  }
`;

export default VideoItem;
